import { API_URL, getAuthHeader } from '@/config';

export const apiCall = async <T,>(
  token: string | null,
  endpoint: string,
  method: string = 'GET',
  body: any = null
): Promise<T> => {
  const url = `${API_URL}${endpoint}`;
  const options: RequestInit = {
    method,
    headers: getAuthHeader(token),
  };

  if (body && method !== 'GET') {
    options.body = JSON.stringify(body);
  }

  const response = await fetch(url, options);

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({ 
      message: `HTTP error! status: ${response.status}` 
    }));
    throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
  }

  const data = await response.json();
  return data;
}; 